import TvFilledIcon from '@/components/Icons/TvFilledIcon';
import { Checkbox, Chip } from '@mui/material';
import { forwardRef } from 'react';
import MultiSelect from './MultiSelect';

const TvIcon = () => <TvFilledIcon className='w-[16px] text-[#1B4332] mr-[4px] -mb-[2px]' />;

const ClientsSelect = forwardRef((props, ref) => {
  return (
    <MultiSelect
      {...props}
      ref={ref}
      renderChip={(option, index, handleDelete) => (
        <Chip
          key={index}
          icon={<TvIcon />}
          label={option.label}
          onDelete={() => handleDelete(index)}
          sx={{
            backgroundColor: 'transparent',
            border: '1px solid #DADADA',
            borderRadius: 32,
            height: 36,
            fontSize: 14,
            '& .tv-filled-icon': {
              margin: '0 -8px -2px 15px',
              color: '#1B4332',
            },
            '& .delete-icon': {
              margin: '0 15px 0 -8px',
            },
          }}
        />
      )}
      renderOption={(optionProps, option, { selected }) => (
        <li {...optionProps}>
          <Checkbox checked={selected} />
          <TvIcon />
          <span>{option.label}</span>
        </li>
      )}
    />
  );
});

ClientsSelect.defaultProps = {
  triggerId: 'client-select',
  placeholder: 'Select Client',
};

export default ClientsSelect;
